<template>
  <img src="@/assets/img/campaign/MANAVIS_thanks.jpg" />
</template>


<style scoped>
</style>

<script>
</script>